import React, { useState } from "react";
import { X, Send, MessageSquare } from "lucide-react";
import toast from "react-hot-toast";
import api from "../api";

export default function FeedbackModal({ isOpen, onClose }) {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!content.trim()) {
      toast.error("Vui lòng nhập nội dung góp ý");
      return;
    }
    setLoading(true);
    try {
      await api.post("/feedback", { content });
      toast.success("Cảm ơn bạn đã đóng góp ý kiến!");
      setContent("");
      onClose();
    } catch (err) {
      toast.error("Có lỗi xảy ra khi gửi góp ý");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div 
        className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-200"
        style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}
      >
        {/* Header */}
        <div className="border-b border-gray-100 p-4 flex items-center justify-between bg-gradient-to-r from-blue-50 to-teal-50">
          <div className="flex items-center space-x-2">
            <div className="bg-white p-1.5 rounded-lg shadow-sm">
              <MessageSquare className="w-5 h-5 text-teal-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-800">Đóng góp ý kiến</h3>
          </div>
          <button 
            onClick={onClose}
            className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-white rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="p-5">
          <p className="text-sm text-gray-500 mb-4">
            Mọi ý kiến đóng góp của bạn đều giúp i-Qualify cải thiện và phục vụ tốt hơn. Vui lòng để lại ý tưởng hoặc báo lỗi tại đây.
          </p>
          
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Bạn muốn i-Qualify cải tiến thêm điều gì?..."
            className="w-full h-32 p-3 text-sm border border-gray-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none resize-none transition-all"
          />

          <div className="mt-5 flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors"
            >
              Hủy
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex items-center space-x-2 px-5 py-2 text-sm font-medium text-white shadow-md disabled:opacity-50 disabled:cursor-not-allowed rounded-lg transition-all"
              style={{ background: "linear-gradient(135deg, #1e3a8a 0%, #14b8a6 100%)" }}
            >
              {loading ? (
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                <Send className="w-4 h-4" />
              )}
              <span>{loading ? "Đang gửi..." : "Gửi góp ý"}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
